<template>
   <div class="transfer-sales-report-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("transferSalesReport_title") }}</h1>
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2">
                        <UISelectBox
                           :key="$i18n.locale"
                           :label="$t('transferSalesReport_filter_lblReportType')"
                           :options="dateTypeOptions"
                           v-model="searchQuery.dateType"
                           light-theme />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('transferSalesReport_filter_lblFromDate')"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date1.max"
                           v-model="searchQuery.date1.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('transferSalesReport_filter_lblToDate')"
                           :min="searchQuery.date2.min"
                           :max="searchQuery.date2.max"
                           v-model="searchQuery.date2.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIMultiSelect
                           :key="$i18n.locale"
                           :label="$t('transferSalesReport_filter_lblStatus')"
                           :options="tnrStatuses"
                           v-model="searchQuery.tnrStatuses"
                           light-theme
                           allow-search />
                     </div>
                  </div>

                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('common_list')" @click.native="listTransferSalesReport" />
                     </div>
                  </div>
               </div>
            </div>

            <template v-if="currentTableOptions.rows.length > 0">
               <ReportSummary entityType="transfer" :summary="summary" />

               <div class="smart-table-wrapper">
                  <SmartTable :options="currentTableOptions" />
               </div>
            </template>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import { reportService } from "@/service/index.js";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import ReportSummary from "@/components/unitary/SalesReportSummary.vue";
import UIDatePicker from "@/components/unitary/form2/UIDatePicker2.vue";
import UIMultiSelect from "@/components/unitary/form2/UIMultiSelect.vue";

export default {
   name: "TransferSalesReport",
   components: {
      Main,
      Aside,
      Navbar,
      UIButton,
      UISelectBox,
      UIDatePicker,
      UIMultiSelect,
      ReportSummary,
   },

   data() {
      return {
         searchQuery: {
            dateType: 1,
            tnrStatuses: [2, 3],
            date1: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            date2: {
               min: moment().subtract(2, "years").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
         },
         tableOptions: {
            columns: [],
            rows: [],
            rules: {
               autoMerge: ["orderId"],
               dominantCell: "orderId",
               showOnMobile: [0, 2, 4, 5, 6],
            },
            options: {
               header: {
                  title: this.$options.name,
                  viewOptions: {
                     status: true,
                     perPage: 50,
                     selects: [
                        { name: `3 ${this.$t("common_order")}`, value: 3 },
                        { name: `5 ${this.$t("common_order")}`, value: 5 },
                        { name: `25 ${this.$t("common_order")}`, value: 25 },
                        { name: `50 ${this.$t("common_order")}`, value: 50 },
                        { name: `100 ${this.$t("common_order")}`, value: 100 },
                        { name: `${this.$t("common_all")}`, value: null },
                     ],
                  },
                  viewMode: "default",
                  saleDateIndex: 9,
               },
               footer: {
                  pagination: {
                     pages: [],
                     activepage: 1,
                  },
               },
            },
         },
         summary: null,
      };
   },
   computed: {
      Direct() {
         return this.$t("transferSalesReport_tblMain_tdChannelGts");
      },
      Provider() {
         return this.$t("transferSalesReport_tblMain_tdChannelProvider");
      },
      dateTypeOptions() {
         return this.$GtsDropdownData.EReportTransferDateType();
      },
      tnrStatuses() {
         return this.$GtsDropdownData.ETrfTnrStatus();
      },
      tableColumns() {
         return [
            { label: this.$t("transferSalesReport_tblMain_thOrderId"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTnr"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thStatus"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thAgencyName"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTransferDate"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thFrom"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTo"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thVehicleType"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTravelerCount"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thSaleDate"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTravelerName"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTravelerSurname"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thAgencyCommission"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thTotal"), status: true },
            { label: this.$t("transferSalesReport_tblMain_thProvider"), status: true },
         ];
      },
      currentTableOptions() {
         return { ...this.tableOptions, columns: this.tableColumns };
      },
   },
   methods: {
      listTransferSalesReport() {
         this.summary = null;
         this.tableOptions.rows = [];

         this.$store.commit("app/setIsProgressGifActive", true);

         let request = {
            dateType: this.searchQuery.dateType,
            statuses: this.searchQuery.tnrStatuses,
            date1: this.searchQuery.date1.value,
            date2: this.searchQuery.date2.value,
         };

         reportService.transferSalesReport(request).then((res) => {
            if (!res.result.success) {
               res.result.service = this.$options.name;
               Popup.result(res.result);
               return;
            }

            if (res.result.success) {
               this.$store.commit("app/setIsProgressGifActive", false);
               this.summary = res.summary;

               res.transfers.map((transfer) => {
                  const rowObj = {
                     orderId: {
                        text: transfer.orderId,
                        class: `gts-badge smart-table-badge-1`,
                        url: `/order/detail/${transfer.orderUuid}`,
                     },
                     tnr: transfer.tnr,
                     tnrStatus: {
                        text: this.$options.filters.ETrfTnrStatus(transfer.tnrStatus),
                        class: `tnr-badge gts-badge ETrfTnrStatus-${transfer.tnrStatus}`,
                     },
                     agencyName: transfer.agencyName,
                     transferDate: {
                        text: this.$options.filters.FormatterDate(transfer.transferDate),
                        class: "",
                     },
                     from: transfer.from,
                     to: transfer.to,
                     transferType: {
                        text: this.$options.filters.ETrfTransferType(transfer.transferType),
                        class: "",
                     },
                     travelerCount: transfer.travelerCount,
                     saleDateTime: {
                        text: this.$options.filters.FormatterDate(transfer.saleDateTime),
                        class: "",
                     },
                     travelerName: transfer.travelerName,
                     travelerSurname: transfer.travelerSurname,
                     agencyCommission: {
                        text: this.$options.filters.price(transfer.agencyCommission, transfer.currency),
                        class: "price-display",
                     },
                     total: {
                        text: this.$options.filters.price(transfer.total, transfer.currency),
                        class: "price-display",
                     },
                     provider: transfer.provider,
                  };
                  this.tableOptions.rows.push(rowObj);
               });
            }
         });
      },
   },
   watch: {
      "searchQuery.dateType"() {
         const isDateType1 = this.searchQuery.dateType === 1;
         const minDate = moment().subtract(2, "years").format(this.$constants.dateFormat);
         const maxDate = isDateType1 ? moment().format(this.$constants.dateFormat) : moment().add(2, "years").format(this.$constants.dateFormat);

         this.searchQuery.date1 = { min: minDate, max: maxDate, value: moment().format(this.$constants.dateFormat) };
         this.searchQuery.date2 = { min: minDate, max: maxDate, value: moment().format(this.$constants.dateFormat) };
      },
      "searchQuery.date1.value"(newDate1) {
         if (moment(newDate1, this.$constants.dateFormat).isAfter(moment(this.searchQuery.date2.value, this.$constants.dateFormat))) {
            this.searchQuery.date2.value = newDate1;
         }
      },
      "searchQuery.date2.value"(newDate2) {
         if (moment(newDate2, this.$constants.dateFormat).isBefore(moment(this.searchQuery.date1.value, this.$constants.dateFormat))) {
            this.searchQuery.date1.value = newDate2;
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.page-container {
   .page-inner {
      width: 90%;
      margin: auto;
      .page-form-row {
         display: grid;
         grid-template-columns: repeat(6, 1fr);
         grid-column-gap: 1rem;
      }
      .page-action-row {
         margin-top: 1rem;
         display: flex;
         justify-content: flex-end;
      }
   }
}
.transfer-sales-report {
   .summary-row {
      grid-template-columns: repeat(5, 1fr) !important;
   }
   .summary-col {
      padding: 0.125rem 1rem !important;
   }
}
</style>
